import { BoundSelectField, Button, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ObjectConfig, required, useFormState } from "@homebound/form-state";
import { Observer } from "mobx-react";
import { Maybe } from "src/generated/graphqlTypes";
import { useBulkTaskAllocationModal_GlobalPlanTasksQuery } from "src/routes/libraries/plan-package/takeoffs/components/BulkTaskAllocationModal/BulkTaskAllocationModal.generated";
import { TakeoffsStoreState } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { StoreApi } from "zustand";

type BulkTaskAllocationModalProps = { store: StoreApi<TakeoffsStoreState>; tliIdsToEdit: string[] };

export function BulkTaskAllocationModal({ store, tliIdsToEdit }: BulkTaskAllocationModalProps) {
  const { closeModal } = useModal();
  const { data } = useBulkTaskAllocationModal_GlobalPlanTasksQuery({ variables: { filter: {} } });
  const formState = useFormState({ config: formConfig });
  async function onSave() {
    const taskId = formState.taskId.value;
    await store.getState().saveTli(tliIdsToEdit.map((id) => ({ id, taskId })));
    closeModal();
  }

  return (
    <>
      <ModalHeader>Task Allocation</ModalHeader>
      <ModalBody>
        <BoundSelectField
          getOptionValue={(o) => o.id}
          getOptionLabel={(o) => o.name}
          options={data?.globalPlanTasks.entities ?? []}
          field={formState.taskId}
        />
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="quaternary" onClick={closeModal} />
        <Observer>
          {() => <Button label="Save" variant="primary" disabled={!formState.valid} onClick={onSave} />}
        </Observer>
      </ModalFooter>
    </>
  );
}

type TaskAllocationFormState = { taskId: Maybe<string> };

const formConfig: ObjectConfig<TaskAllocationFormState> = { taskId: { type: "value", rules: [required] } };
